"use strict";

var objectAssign = require('object-assign');
var buildMarksTree = require('./buildMarksTree');
var nestLists = require('./nestLists');
var generateKeys = require('./generateKeys');
var mergeSerializers = require('./mergeSerializers'); // Properties to extract from props and pass to serializers as options

var optionProps = ['projectId', 'dataset', 'imageOptions', 'ignoreUnknownTypes'];
var isDefined = function isDefined(val) {
  return typeof val !== 'undefined';
};
var defaults = {
  imageOptions: {},
  ignoreUnknownTypes: true
};
function blocksToNodes(h, properties, defaultSerializers, serializeSpan) {
  var props = objectAssign({}, defaults, properties);
  var rawBlocks = Array.isArray(props.blocks) ? props.blocks : [props.blocks];
  var keyedBlocks = generateKeys(rawBlocks);
  var blocks = nestLists(keyedBlocks, props.listNestMode);
  var serializers = mergeSerializers(defaultSerializers, props.serializers || {});
  var options = optionProps.reduce(function (opts, key) {
    var value = props[key];
    if (isDefined(value)) {
      opts[key] = value;
    }
    return opts;
  }, {});
  function serializeNode(node, index, siblings, isInline) {
    if (isList(node)) {
      return serializeList(node);
    }
    if (isListItem(node)) {
      return serializeListItem(node, findListItemIndex(node, siblings));
    }
    if (isSpan(node)) {
      return serializeSpan(node, serializers, index, {
        serializeNode: serializeNode
      });
    }
    return serializeBlock(node, index, isInline);
  }
  function findListItemIndex(node, siblings) {
    var index = 0;
    for (var i = 0; i < siblings.length; i++) {
      if (siblings[i] === node) {
        return index;
      }
      if (!isListItem(siblings[i])) {
        continue;
      }
      index++;
    }
    return index;
  }
  function serializeBlock(block, index, isInline) {
    var tree = buildMarksTree(block);
    var children = tree.map(function (node, i, siblings) {
      return serializeNode(node, i, siblings, true);
    });
    var blockProps = {
      key: block._key || "block-".concat(index),
      node: block,
      isInline: isInline,
      serializers: serializers,
      options: options
    };
    return h(serializers.block, blockProps, children);
  }
  function serializeListItem(block, index) {
    var key = block._key;
    var tree = buildMarksTree(block);
    var children = tree.map(serializeNode);
    return h(serializers.listItem, {
      node: block,
      serializers: serializers,
      index: index,
      key: key,
      options: options
    }, children);
  }
  function serializeList(list) {
    var type = list.listItem;
    var level = list.level;
    var key = list._key;
    var children = list.children.map(serializeNode);
    return h(serializers.list, {
      key: key,
      level: level,
      type: type,
      options: options
    }, children);
  } // Default to false, so `undefined` will evaluate to the default here

  var renderContainerOnSingleChild = Boolean(props.renderContainerOnSingleChild);
  var nodes = blocks.map(serializeNode);
  if (renderContainerOnSingleChild || nodes.length > 1) {
    var containerProps = props.className ? {
      className: props.className
    } : {};
    return h(serializers.container, containerProps, nodes);
  }
  if (nodes[0]) {
    return nodes[0];
  }
  return typeof serializers.empty === 'function' ? h(serializers.empty) : serializers.empty;
}
function isList(block) {
  return block._type === 'list' && block.listItem;
}
function isListItem(block) {
  return block._type === 'block' && block.listItem;
}
function isSpan(block) {
  return typeof block === 'string' || block.marks || block._type === 'span';
}
module.exports = blocksToNodes;